/**
 * AB Test Actions
 * NgRx actions for managing AB test state
 *
 * Note: Variant assignments are handled client-side via VariantAssignmentService
 * with localStorage. VariantAssignmentActions are kept for backwards compatibility
 * but don't affect NgRx state.
 */

import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ABTestDefinition, AnalyticsEvent, VariantAssignment } from '../interfaces/models';

// AB Test Configuration Actions
export const ABTestConfigActions = createActionGroup({
  source: 'AB Test Config',
  events: {
    'Load Active Tests': emptyProps(),
    'Load Active Tests Success': props<{ tests: ABTestDefinition[] }>(),
    'Load Active Tests Failure': props<{ error: string }>(),
  },
});

// Variant Assignment Actions
// Note: These actions update NgRx state for client-side variant assignments
// (stored in localStorage). No backend API calls are made.
export const VariantAssignmentActions = createActionGroup({
  source: 'Variant Assignment',
  events: {
    'Load Assignments Success': props<{ assignments: VariantAssignment[] }>(),
    'Create Assignment Success': props<{ assignment: VariantAssignment }>(),
    'Update Assignment': props<{ assignment: VariantAssignment }>(),
    'Delete Assignment': props<{ testId: string; userId: string }>(),
    'Clean Expired Assignments': emptyProps(),
  },
});

// Event Tracking Actions
export const EventTrackingActions = createActionGroup({
  source: 'Event Tracking',
  events: {
    'Track Event': props<{ event: AnalyticsEvent }>(),
    'Batch Events': props<{ events: AnalyticsEvent[] }>(),
    'Send Events Success': emptyProps(),
    'Send Events Failure': props<{ error: string; events: AnalyticsEvent[] }>(),
    'Track EduContent Interaction': props<{
      action: string;
      elementId: string;
      properties?: Record<string, unknown>;
    }>(),
  },
});
